
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { TheMask } from 'vue-the-mask';
import { Money } from 'v-money';
import { Tooltip } from '@/modules/common/components/Tooltip';
import { FormField } from '@/modules/common/components/__deprecated__/FormField';
import { Label } from '@/modules/common/components/__deprecated__/Label';
import {
  ActionCloseModal,
  ActionSendLead,
  State
} from '@/modules/pension/store/pension-landing';
import {
  Button,
  Modal,
  ModalButton,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

const PensionModule = namespace('PensionLandingModule');

@Component({
  components: {
    Button,
    Modal,
    ModalButton,
    Label,
    FormField,
    TheMask,
    Money,
    Tooltip,
    BaseText
  }
})
export default class PensionModalContact extends Vue {
  readonly NebraskaColors = NebraskaColors;

  @PensionModule.State('data')
  state!: State;

  @PensionModule.Action('sendLead')
  sendLead!: ActionSendLead;

  @PensionModule.Action('closeModal')
  closeModal!: ActionCloseModal;

  /**
   * Computed lead first name.
   */
  get leadFirstName(): string {
    const { lead } = this.state;
    const name = lead.name.split(' ');
    return name[0] || lead.name;
  }

  /**
   * Returns a string error from key (email, name, etc).
   */
  getValidationError(key: string): string | null {
    const { validator } = this.state;
    return validator.lead.getError(key);
  }
}
